export const LOADER_PERIODO_EVALUACION         =       'LOADER_PERIODO_EVALUACION';
export const GET_PERIODO_EVALUACION             =       'GET_PERIODO_EVALUACION';
export const PERIODO_EVALUACION_FALLA          =       'PERIODO_EVALUACION_FALLA';
export const SAVE_LOADER_PERIODO_EVALUACION     =       'SAVE_LOADER_PERIODO_EVALUACION';
export const FORM_PERIODO_EVALUACION_FAIL      =       'FORM_PERIODO_EVALUACION_FAIL';

